import { render } from "./DelList.vue?vue&type=template&id=334fbad4&ts=true"
import script from "./DelList.vue?vue&type=script&lang=ts"
export * from "./DelList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/zhongyue/Desktop/work/hu-shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__